import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "header-menu align-items-stretch",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "header-menu",
  "data-kt-drawer-activate": "{default: true, lg: false}",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_header_menu_mobile_toggle",
  "data-kt-place": "true",
  "data-kt-place-mode": "prepend",
  "data-kt-place-parent": "{default: '#kt_body', lg: '#kt_header_nav'}"
}
const _hoisted_2 = {
  class: "menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch",
  id: "#kt_header_menu",
  "data-kt-menu": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "menu-item me-lg-1"
}
const _hoisted_4 = ["href", "onClick"]
const _hoisted_5 = { class: "menu-title" }
const _hoisted_6 = {
  key: 1,
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-lg-down-accordion me-lg-1"
}
const _hoisted_7 = { class: "menu-title" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow d-lg-none" }, null, -1)
const _hoisted_9 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px" }
const _hoisted_10 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-lg-down-accordion"
}
const _hoisted_11 = { class: "menu-icon" }
const _hoisted_12 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_13 = { class: "menu-title" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_15 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px" }
const _hoisted_16 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-lg-down-accordion"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_18 = { class: "menu-title" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_20 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_22 = { class: "menu-title" }
const _hoisted_23 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_25 = { class: "menu-title" }
const _hoisted_26 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_27 = { class: "menu-icon" }
const _hoisted_28 = { class: "svg-icon svg-icon-2" }
const _hoisted_29 = { class: "menu-title" }
const _hoisted_30 = {
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-lg-down-accordion me-lg-1"
}
const _hoisted_31 = { class: "menu-link py-3" }
const _hoisted_32 = { class: "menu-title" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow d-lg-none" }, null, -1)
const _hoisted_34 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px" }
const _hoisted_35 = { class: "menu-item" }
const _hoisted_36 = {
  class: "menu-link py-3",
  href: "https://preview.keenthemes.com/metronic8/vue/docs/#/utilities"
}
const _hoisted_37 = { class: "menu-icon" }
const _hoisted_38 = {
  key: 0,
  class: "bi bi-box fs-3"
}
const _hoisted_39 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_40 = { class: "menu-title" }
const _hoisted_41 = { class: "menu-item" }
const _hoisted_42 = {
  class: "menu-link py-3",
  href: "https://preview.keenthemes.com/metronic8/vue/docs/#/doc-overview"
}
const _hoisted_43 = { class: "menu-icon" }
const _hoisted_44 = {
  key: 0,
  class: "bi bi-card-text fs-3"
}
const _hoisted_45 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_46 = { class: "menu-title" }
const _hoisted_47 = { class: "menu-item" }
const _hoisted_48 = {
  class: "menu-link py-3",
  href: "https://preview.keenthemes.com/metronic8/vue/docs/#/changelog"
}
const _hoisted_49 = { class: "menu-icon" }
const _hoisted_50 = {
  key: 0,
  class: "bi bi-journal-code fs-3"
}
const _hoisted_51 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_52 = { class: "menu-title" }
const _hoisted_53 = {
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-lg-down-accordion me-lg-1"
}
const _hoisted_54 = { class: "menu-link py-3" }
const _hoisted_55 = { class: "menu-title" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow d-lg-none" }, null, -1)
const _hoisted_57 = {
  class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown w-100 w-lg-600px p-5 p-lg-5",
  style: {}
}
const _hoisted_58 = {
  class: "row",
  "data-kt-menu-dismiss": "true"
}
const _hoisted_59 = { class: "col-lg-4 border-left-lg-1" }
const _hoisted_60 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_61 = { class: "menu-item" }
const _hoisted_62 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_64 = { class: "menu-title" }
const _hoisted_65 = { class: "menu-item" }
const _hoisted_66 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_68 = { class: "menu-title" }
const _hoisted_69 = { class: "menu-item" }
const _hoisted_70 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_72 = { class: "menu-title" }
const _hoisted_73 = { class: "menu-item" }
const _hoisted_74 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_76 = { class: "menu-title" }
const _hoisted_77 = { class: "menu-item" }
const _hoisted_78 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_80 = { class: "menu-title" }
const _hoisted_81 = { class: "col-lg-4 border-left-lg-1" }
const _hoisted_82 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_83 = { class: "menu-item" }
const _hoisted_84 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_86 = { class: "menu-title" }
const _hoisted_87 = { class: "menu-item" }
const _hoisted_88 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_90 = { class: "menu-title" }
const _hoisted_91 = { class: "menu-item" }
const _hoisted_92 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_94 = { class: "menu-title" }
const _hoisted_95 = { class: "menu-item" }
const _hoisted_96 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_98 = { class: "menu-title" }
const _hoisted_99 = { class: "menu-item" }
const _hoisted_100 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_101 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_102 = { class: "menu-title" }
const _hoisted_103 = { class: "col-lg-4 border-left-lg-1" }
const _hoisted_104 = { class: "menu-inline menu-column menu-active-bg" }
const _hoisted_105 = { class: "menu-item" }
const _hoisted_106 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_108 = { class: "menu-title" }
const _hoisted_109 = { class: "menu-item" }
const _hoisted_110 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_111 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_112 = { class: "menu-title" }
const _hoisted_113 = { class: "menu-item" }
const _hoisted_114 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_116 = { class: "menu-title" }
const _hoisted_117 = { class: "menu-item" }
const _hoisted_118 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_119 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_120 = { class: "menu-title" }
const _hoisted_121 = { class: "menu-item" }
const _hoisted_122 = {
  href: "#",
  class: "menu-link"
}
const _hoisted_123 = /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_124 = { class: "menu-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MainMenuConfig, (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          (!item.heading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.pages, (menuItem, j) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                  (menuItem.heading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_router_link, {
                          to: menuItem.route
                        }, {
                          default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                            _createElementVNode("a", {
                              href: href,
                              class: _normalizeClass(["menu-link py-3", [isActive && 'active', isExactActive && 'active']]),
                              onClick: navigate
                            }, [
                              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                            ], 10, _hoisted_4)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : _createCommentVNode("", true),
          (item.heading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", {
                  class: _normalizeClass(["menu-link py-3", { active: _ctx.hasActiveChildren(item.route) }])
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.translate(item.heading)), 1),
                  _hoisted_8
                ], 2),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                      (menuItem.sectionTitle)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["menu-link py-3", { active: _ctx.hasActiveChildren(menuItem.route) }])
                            }, [
                              _createElementVNode("span", _hoisted_11, [
                                (_ctx.headerMenuIcons === 'font')
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 0,
                                      class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                    }, null, 2))
                                  : _createCommentVNode("", true),
                                (_ctx.headerMenuIcons === 'svg')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                      _createVNode(_component_inline_svg, {
                                        src: menuItem.svgIcon
                                      }, null, 8, ["src"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.translate(menuItem.sectionTitle)), 1),
                              _hoisted_14
                            ], 2),
                            _createElementVNode("div", _hoisted_15, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.sub, (menuItem1, k) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                  (menuItem1.sectionTitle)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["menu-link py-3", { active: _ctx.hasActiveChildren(menuItem1.route) }])
                                        }, [
                                          _hoisted_17,
                                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.translate(menuItem1.sectionTitle)), 1),
                                          _hoisted_19
                                        ], 2),
                                        _createElementVNode("div", _hoisted_20, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem1.sub, (menuItem2, l) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: l,
                                              class: "menu-item"
                                            }, [
                                              _createVNode(_component_router_link, {
                                                class: "menu-link py-3",
                                                "active-class": "active",
                                                to: menuItem2.route
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_21,
                                                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.translate(menuItem2.heading)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["to"])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (menuItem1.heading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                        _createVNode(_component_router_link, {
                                          class: "menu-link py-3",
                                          to: menuItem1.route
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_24,
                                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.translate(menuItem1.heading)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (menuItem.heading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createVNode(_component_router_link, {
                              class: "menu-link py-3",
                              to: menuItem.route
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_27, [
                                  _createElementVNode("span", _hoisted_28, [
                                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/layouts/lay009.svg" })
                                  ])
                                ]),
                                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("span", _hoisted_31, [
          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.translate("resources")), 1),
          _hoisted_33
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("a", _hoisted_36, [
              _createElementVNode("span", _hoisted_37, [
                (_ctx.headerMenuIcons === 'font')
                  ? (_openBlock(), _createElementBlock("i", _hoisted_38))
                  : _createCommentVNode("", true),
                (_ctx.headerMenuIcons === 'svg')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen002.svg" })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.translate("components")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("a", _hoisted_42, [
              _createElementVNode("span", _hoisted_43, [
                (_ctx.headerMenuIcons === 'font')
                  ? (_openBlock(), _createElementBlock("i", _hoisted_44))
                  : (_ctx.headerMenuIcons === 'svg')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.translate("documentation")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("a", _hoisted_48, [
              _createElementVNode("span", _hoisted_49, [
                (_ctx.headerMenuIcons === 'font')
                  ? (_openBlock(), _createElementBlock("i", _hoisted_50))
                  : (_ctx.headerMenuIcons === 'svg')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/coding/cod003.svg" })
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.translate("changelog")) + " v" + _toDisplayString(_ctx.version), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("span", _hoisted_54, [
          _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.translate("megaMenu")), 1),
          _hoisted_56
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("a", _hoisted_62, [
                    _hoisted_63,
                    _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("a", _hoisted_66, [
                    _hoisted_67,
                    _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("a", _hoisted_70, [
                    _hoisted_71,
                    _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("a", _hoisted_74, [
                    _hoisted_75,
                    _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("a", _hoisted_78, [
                    _hoisted_79,
                    _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("a", _hoisted_84, [
                    _hoisted_85,
                    _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_87, [
                  _createElementVNode("a", _hoisted_88, [
                    _hoisted_89,
                    _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("a", _hoisted_92, [
                    _hoisted_93,
                    _createElementVNode("span", _hoisted_94, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("a", _hoisted_96, [
                    _hoisted_97,
                    _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_99, [
                  _createElementVNode("a", _hoisted_100, [
                    _hoisted_101,
                    _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("div", _hoisted_105, [
                  _createElementVNode("a", _hoisted_106, [
                    _hoisted_107,
                    _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("a", _hoisted_110, [
                    _hoisted_111,
                    _createElementVNode("span", _hoisted_112, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("a", _hoisted_114, [
                    _hoisted_115,
                    _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_117, [
                  _createElementVNode("a", _hoisted_118, [
                    _hoisted_119,
                    _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("a", _hoisted_122, [
                    _hoisted_123,
                    _createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.translate("exampleLink")), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}